import React, { FC, useState } from "react";
import classNames from "classnames";
import styles from "./LongDropDownElement.module.scss";
import ArrowDownIcon from "assets/svg/arrow-down.svg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

interface DropDownElementProps {
  setSelectedElement: (val: { id: number | null; name: string }) => void;
  selectedElement: { id: number | null; name: string } | null;
  title: string;
  data: { id: number | null; name: string }[];
}

const LongDropDownElement: FC<DropDownElementProps> = ({
  selectedElement,
  setSelectedElement,
  title,
  data,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const selectStudio = (val: { id: number | null; name: string }) => {
    setSelectedElement(val);
    handleMenuClose();
  };

  return (
    <div
      className={classNames(
        styles.studioTypeContainer,
        "flex gap8 a-items-c full-width",
      )}
    >
      <div className={"flex a-items-c flex-start gap24 full-width"}>
        <div
          onClick={handleMenuOpen}
          className={"flex a-items-c cursor-pointer"}
          style={{
            background: "rgba(30, 30, 30, 1)",
            height: 40,
            width: "100%",
            paddingLeft: 8,
            paddingRight: 8,
            borderRadius: 8,
            justifyContent: "space-between",
          }}
        >
          <span
            style={{
              width: "auto",
              marginLeft: 10,
              color: "rgba(152, 152, 152, 1)",
              fontFamily: "MatterRegular",
              fontSize: 12,
            }}
          >
            {selectedElement ? selectedElement.name : title}
          </span>
          <img src={ArrowDownIcon} alt="" width={24} height={24} />
        </div>
        <Menu
          id="menu-basic"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
            sx: {
              background: "rgba(30, 30, 30, 1)",
              borderRadius: "16px",
              borderWidth: 0,
              color: "rgba(152, 152, 152, 1)",
              fontSize: 12,
              width: 600,
              fontFamily: "MatterRegular",
              overflow: "hidden",
            },
          }}
          PaperProps={{ sx: { background: "inherit" } }}
        >
          {data.map((studio) => (
            <MenuItem key={studio.id} onClick={() => selectStudio(studio)}>
              {studio.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    </div>
  );
};

export default LongDropDownElement;
